export const DIARY_MOOD_OPTIONS = [
  { id: "awful", score: 2, emoji: "😞", label: "Ужасно" },
  { id: "bad", score: 4, emoji: "😔", label: "Плохо" },
  { id: "ok", score: 6, emoji: "😐", label: "Нейтрально" },
  { id: "good", score: 8, emoji: "🙂", label: "Хорошо" },
  { id: "great", score: 10, emoji: "😄", label: "Отлично" },
];

export function diaryMoodOptionById(id) {
  return DIARY_MOOD_OPTIONS.find((option) => option.id === String(id || "").trim()) || null;
}

export function diaryMoodScoreFromId(id) {
  return diaryMoodOptionById(id)?.score ?? null;
}

export function diaryMoodOptionByScore(score) {
  const numericScore = Number(score);
  if (!Number.isFinite(numericScore)) return null;

  return DIARY_MOOD_OPTIONS.reduce((best, option) => {
    if (!best) return option;
    const bestDistance = Math.abs(best.score - numericScore);
    const nextDistance = Math.abs(option.score - numericScore);
    return nextDistance < bestDistance ? option : best;
  }, null);
}

export function diaryMoodLabel(score) {
  return diaryMoodOptionByScore(score)?.label || "";
}

export function diaryMoodBadge(score) {
  const option = diaryMoodOptionByScore(score);
  return option ? `${option.emoji} ${option.label}` : "";
}

export function diaryQuickEntryTitle(score) {
  const option = diaryMoodOptionByScore(score);
  return option ? `Ежедневный чек-ин: ${option.label}` : "Ежедневный чек-ин";
}

export function diaryQuickEntryContent(score, note = "") {
  const cleanNote = String(note || "").trim();
  if (cleanNote) return cleanNote;

  const option = diaryMoodOptionByScore(score);
  if (option) {
    return `Сегодня отмечаю своё состояние как "${option.label}".`;
  }

  return "Короткая заметка о сегодняшнем состоянии.";
}
